import React from 'react';

export const Description = props => {
  const { children, style, type } = props;
  const bgClass =
    type === 'primary'
      ? 'Description--primary'
      : type === 'notice'
      ? 'Description--notice'
      : type === 'warning'
      ? 'Description--warning'
      : '';
  return (
    <div className={`Description ${bgClass}`} style={style}>
      <div className='Description__content'>{children}</div>
    </div>
  );
};

export const DescriptionText = props => {
  const { children, textSize } = props;
  const textClass =
    textSize === 'small'
      ? 'DescriptionText DescriptionText--small'
      : 'DescriptionText';
  return <div className={textClass}>{children}</div>;
};



// WEBPACK FOOTER //
// ./src/components/Description.jsx